module.exports = __webpack_public_path__ + "881029125.jpg";